<template>
    <div class="page-content">
        <feed-item :showControls="false" :content="insight" v-if="insight"></feed-item>
        <tableau-viz :view="view" :brand="insight.brand" :loggedIn="loggedIn" @viewLoaded="onViewLoaded" v-if="view" />
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import TableauViz from '../TableauViz.vue'
    import FeedItem from '../FeedItem.vue'

    export default {
        name: 'InsightView',
        components: {
            'feed-item': FeedItem,
            'tableau-viz': TableauViz
        },
        props: {
            code: {
                type: String,
                required: true
            },
            product: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                loggedIn: false
            }
        },
        computed: {
            ...mapGetters(['insights', 'views']),
            insight() {
                return this.insights ? this.insights.filter(i => i.code == this.code && i.product == this.product)[0] : null
            },
            view() {
                return this.insight && this.views ? this.views.filter(v => v.contentUrl == this.insight.contentUrl)[0] : null
            }
        },
        methods: {
            async onViewLoaded() {
                this.loggedIn = true
                await this.logEvent('View loaded')
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../styles/base';

    .page-content {
        display: flex;
        flex-direction: column;
    }
</style>
